import { render, staticRenderFns } from "./LayoutBase.vue?vue&type=template&id=0d9af265&scoped=true"
import script from "./LayoutBase.vue?vue&type=script&lang=js"
export * from "./LayoutBase.vue?vue&type=script&lang=js"
import style0 from "./LayoutBase.vue?vue&type=style&index=0&id=0d9af265&lang=scss&scoped=true"
import style1 from "./LayoutBase.vue?vue&type=style&index=1&id=0d9af265&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9af265",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d9af265')) {
      api.createRecord('0d9af265', component.options)
    } else {
      api.reload('0d9af265', component.options)
    }
    module.hot.accept("./LayoutBase.vue?vue&type=template&id=0d9af265&scoped=true", function () {
      api.rerender('0d9af265', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layout/LayoutBase.vue"
export default component.exports